var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M3 2.5v6c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-6",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M6 2.5v19",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M18 2.5c-1.7 0-3 1.8-3 4.5s1.3 4.5 3 4.5",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _c("path", {
        attrs: {
          d: "M18 2.5v19",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }